<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="'司机油/气耗费用上传'"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="500px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
          type="primary"
          @click="customFormPost"
          :loading="subLoading || getDetailLoading"
      >确定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  gasConsumptionSaveOrUpdate,
  oilConsumptionSaveOrUpdate,
} from 'api/operate';
import {dealNumber, floatSub} from '@qx/utils';
const aImgName = ['startingKilometerList', 'endKilometerList', 'oilRiseImgList', 'startingKilometerImgList', 'endKilometerImgList', 'gasFillingQuantityImgList'];
export default {
  data () {
    return {
      proof: [],
      detailRes: {},
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      originData: {},
      id: '',
      formData: {
        form: [
          // 油耗start
          {
            label: '公里数',
            value: 'kilometre',
            type: 'input',
            unit: '（KM）',
            onBlur: () => {
              this.kilometreChange();
            },
            hide: true,
          },
          {
            label: '每公里实际消耗',
            value: 'actualOilConsumption',
            type: 'show',
            unit: '（升）',
            hide: true,
          },
          {
            label: '每公里规定标准',
            value: 'standardOilConsumption',
            type: 'input',
            unit: '（升）',
            placeholder: '可支持小数点后3位数字',
            onBlur: () => {
              this.kilometreChange();
            },
            hide: true,
          },
          {
            label: '规定燃油量',
            value: 'standardRise',
            type: 'show',
            unit: 'L',
            hide: true,
          },
          {
            label: '实际加油升数',
            value: 'oilRise',
            type: 'input',
            unit: '（L）',
            onBlur: () => {
              this.oilRiseChange();
            },
            hide: true,
          },
          {
            label: '结余数量',
            value: 'surplusRise',
            type: 'show',
            unit: 'L',
            hide: true,
          },
          {
            label: '本趟油补',
            value: 'oilSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾油补',
            value: 'mainDriverSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾油补比例',
            value: 'oilSubsidyScaleMain',
            type: 'input',
            unit: '%',
            onInput: (oilSubsidyScaleMain) => {
              this.$refs.customForm.setVal('oilSubsidyScaleMain', dealNumber(oilSubsidyScaleMain, false));
            },
            onBlur: () => {
              this.oilSubsidyChange();
            },
            hide: true,
          },
          {
            label: '副驾油补',
            value: 'coDriverSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '副驾油补比例',
            value: 'coOilSubsidyScaleMain',
            type: 'show',
            unit: '%',
            hide: true,
          },
          {
            label: '起始公里数',
            value: 'startingKilometerList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            hide: true,
          },
          {
            label: '终点公里数',
            value: 'endKilometerList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            hide: true,
          },
          {
            label: '加油升数',
            value: 'oilRiseImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            hide: true,
          },
          // 油耗end
          // 气耗start
          {
            label: '公里数',
            value: 'gasKilometre',
            type: 'input',
            unit: '（KM）',
            onBlur: () => {
              this.gasKilometreChange();
            },
            hide: true,
          },
          {
            label: '每公里实际消耗',
            value: 'actualConsPerKilo',
            type: 'show',
            unit: 'KG',
            // onBlur: () => {
            //   this.gasKilometreChange();
            // },
            hide: true,
          },
          {
            label: '每公里规定标准',
            value: 'standardConsPerKilo',
            type: 'input',
            unit: 'KG',
            hide: true,
            onBlur: () => {
              this.gasKilometreChange();
            },
          },
          {
            label: '规定燃气量',
            value: 'standardGasInjectionVolume',
            type: 'show',
            unit: 'KG',
            hide: true,
          },
          {
            label: '实际加气量',
            value: 'actualGasInjectionVolume',
            type: 'input',
            unit: '（KG）',
            onBlur: () => {
              this.gasKilometreChange();
            },
            hide: true,
          },
          {
            label: '结余气量',
            value: 'surplusGasVolume',
            type: 'show',
            unit: '（KG）',
            hide: true,
          },
          {
            label: '本趟气补',
            value: 'gasSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾气补',
            value: 'mainDriverGasSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '主驾气补比例',
            value: 'gasSubsidyScaleMain',
            type: 'input',
            unit: '%',
            onInput: (gasSubsidyScaleMain) => {
              this.$refs.customForm.setVal('gasSubsidyScaleMain', dealNumber(gasSubsidyScaleMain, false));
            },
            onBlur: () => {
              this.gasSubsidyChange();
            },
            hide: true,
          },
          {
            label: '副驾气补',
            value: 'coDriverGasSubsidy',
            type: 'show',
            unit: '元',
            hide: true,
          },
          {
            label: '副驾气补比例',
            value: 'coGasSubsidyScaleMain',
            type: 'show',
            unit: '%',
            hide: true,
          },
          {
            label: '起始公里数',
            value: 'startingKilometerImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            hide: true,
          },
          {
            label: '终点公里数',
            value: 'endKilometerImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            hide: true,
          },
          {
            label: '加气数量',
            value: 'gasFillingQuantityImgList',
            type: 'img',
            accept: 'image/*',
            previewAsImage: true,
            default: [],
            hide: true,
          },
          // 气耗end
        ],
        rules: {
          // 油耗start
          kilometre: [
            { required: true, message: '请输入公里数', trigger: 'blur' },
            {validator: this.validateKilomere, trigger: 'blur'},
          ],
          standardOilConsumption: [
            { required: true, message: '请输入百公里规定标准', trigger: 'blur' },
            {validator: this.validateStandardOilConsumption, trigger: 'blur'},
          ],
          oilRise: [
            { required: true, message: '请输入加油升数', trigger: 'blur' },
            {validator: this.validateOilRise, trigger: 'blur'},
          ],
          startingKilometerList: [
            { required: true, message: '请上传起始公里数', trigger: 'blur' },
          ],
          endKilometerList: [
            { required: true, message: '请上传终点公里数', trigger: 'blur' },
          ],
          oilRiseImgList: [
            { required: true, message: '请上传加油升数', trigger: 'blur' },
          ],
          oilSubsidyScaleMain: [
            { required: false, message: '请输入主驾油补比例', trigger: 'blur' },
            {validator: this.checkOilSubsidyScaleMain, trigger: 'blur'},
          ],
          // 油耗end
          // 气耗start
          gasKilometre: [
            { required: true, message: '请输入公里数', trigger: 'blur' },
            {validator: this.validateKilomere, trigger: 'blur'},
          ],
          actualGasInjectionVolume: [
            { required: true, message: '请输入实际加气量', trigger: 'blur' },
            {validator: this.validateKactualGasInjectionVolume, trigger: 'blur'},
          ],
          standardConsPerKilo: [
            { required: true, message: '请输入每公里规定标准', trigger: 'blur' },
            {validator: this.validateStandardConsPerKilo, trigger: 'blur'},
          ],
          gasSubsidyScaleMain: [
            { required: false, message: '请输入主驾气补比例', trigger: 'blur' },
            {validator: this.checkGasSubsidyScaleMain, trigger: 'blur'},
          ],
          startingKilometerImgList: [
            { required: true, message: '请上传起始公里数', trigger: 'blur' },
          ],
          endKilometerImgList: [
            { required: true, message: '请上传终点公里数', trigger: 'blur' },
          ],
          gasFillingQuantityImgList: [
            { required: true, message: '请上传加气数量', trigger: 'blur' },
          ],
          // 气耗end

        },
      },
    };
  },
  methods: {
    validateStandardConsPerKilo (rule, value, call) {
      this.validateNumberInput(rule, value, call, '每公里规定标准不可为负数');
    },
    checkOilSubsidyScaleMain (rule, value, call) {
      if (value > 100) {
        call('主驾油补比例不能大于100%');
      } else {
        call();
      }
    },
    checkGasSubsidyScaleMain (rule, value, call) {
      if (value > 100) {
        call('主驾气补比例不能大于100%');
      } else {
        call();
      }
    },
    validateNumberInput (rule, value, call, errorMessage) {
      if (value < 0) {
        call(errorMessage);
      } else if (isNaN(value)) {
        call('只可输入数字');
      } else {
        call();
      }
    },
    validateKilomere (rule, value, call) {
      if (value <= 0) {
        call('公里数不可为负数或零');
      } else if (isNaN(value)) {
        call('只可输入数字');
      } else {
        call();
      }
    },
    validateStandardOilConsumption (rule, value, call) {
      this.validateNumberInput(rule, value, call, '百公里规定标准不可为负数');
    },
    validateOilRise (rule, value, call) {
      this.validateNumberInput(rule, value, call, '加油升数不可为负数');
    },
    validateKactualGasInjectionVolume (rule, value, call) {
      this.validateNumberInput(rule, value, call, '实际加气量不可为负数');
    },
    // 处理数据为整数时，就不保留小数点后两位
    numberFormat (num) {
      if (!isNaN(num)) {
        let str = num.toString();
        let strIndex = str.indexOf('.');
        if (strIndex === -1) {
          return str;
        }
        str = num.toString().substring(strIndex + 1);
        if (str > 0) {
          return Number(num).toFixed(2);
        } else {
          return num;
        }
      }
    },
    // 油耗公里数改变
    kilometreChange () {
      let kilometre = this.$refs.customForm.getVal('kilometre');
      this.numberFormat(kilometre);
      let standardOilConsumption = this.$refs.customForm.getVal('standardOilConsumption');
      let oilRise = this.$refs.customForm.getVal('oilRise');
      if (kilometre && standardOilConsumption) {
        this.$refs.customForm.setVal('standardRise', (kilometre * standardOilConsumption).toFixed(3));
      }
      if (oilRise) {
        this.oilRiseChange();
      }
    },
    // 油耗加油升数改变
    oilRiseChange () {
      let standardOilConsumption = this.$refs.customForm.getVal('standardOilConsumption');
      let standardRise = this.$refs.customForm.getVal('standardRise');
      let oilRise = this.$refs.customForm.getVal('oilRise');
      let kilometre = this.$refs.customForm.getVal('kilometre');
      if (kilometre && oilRise) {
        this.$refs.customForm.setVal('actualOilConsumption', (oilRise / kilometre).toFixed(3));
      }
      if (standardOilConsumption && oilRise) {
        this.$refs.customForm.setVal('surplusRise', (standardRise - oilRise).toFixed(3));
        let surplusRise = this.$refs.customForm.getVal('surplusRise');

        if (surplusRise <= 0) {
          this.$refs.customForm.setVal('oilSubsidy', -Math.round(Math.abs(surplusRise * 6)));
        } else {
          this.$refs.customForm.setVal('oilSubsidy', Math.round(surplusRise * 5));
        }
        this.oilSubsidyChange();
      }
    },
    // 主驾油补比例计算
    oilSubsidyChange () {
      let oilSubsidyScaleMain = this.$refs.customForm.getVal('oilSubsidyScaleMain');
      if (Number(oilSubsidyScaleMain) >= 0 && Number(oilSubsidyScaleMain) <= 100) {
        this.$refs.customForm.setVal('coOilSubsidyScaleMain', floatSub(100, oilSubsidyScaleMain));
        // 主驾和副驾油补计算
        let oilSubsidy = this.$refs.customForm.getVal('oilSubsidy');
        this.$refs.customForm.setVal('mainDriverSubsidy', Math.round(oilSubsidy * oilSubsidyScaleMain / 100));
        const mainDriverSubsidy = this.$refs.customForm.getVal('mainDriverSubsidy');
        this.$refs.customForm.setVal('coDriverSubsidy', oilSubsidy - mainDriverSubsidy);
      }
    },

    // 气耗公里数或实际加气量改变
    gasKilometreChange () {
      const gasKilometre = this.$refs.customForm.getVal('gasKilometre');
      const standardConsPerKilo = this.$refs.customForm.getVal('standardConsPerKilo');
      if (gasKilometre && standardConsPerKilo && Number(gasKilometre) >= 0 && Number(standardConsPerKilo) >= 0) {
        let standardGasInjectionVolume = (standardConsPerKilo * gasKilometre).toFixed(3);
        this.$refs.customForm.setVal('standardGasInjectionVolume', standardGasInjectionVolume);
        const actualGasInjectionVolume = this.$refs.customForm.getVal('actualGasInjectionVolume');
        if (actualGasInjectionVolume && Number(actualGasInjectionVolume) >= 0) {
          this.$refs.customForm.setVal('surplusGasVolume', ((standardGasInjectionVolume * 1000 - actualGasInjectionVolume * 1000) / 1000).toFixed(3));

          this.$refs.customForm.setVal('actualConsPerKilo', (actualGasInjectionVolume / gasKilometre).toFixed(3));

          let surplusGasVolume = this.$refs.customForm.getVal('surplusGasVolume');

          if (surplusGasVolume <= 0) {
            this.$refs.customForm.setVal('gasSubsidy', -Math.round(Math.abs(surplusGasVolume * 4)));
          } else {
            this.$refs.customForm.setVal('gasSubsidy', Math.round(surplusGasVolume * 4));
          }
          this.gasSubsidyChange();
        }
      }
    },

    // 主驾气补比例计算
    gasSubsidyChange () {
      let gasSubsidyScaleMain = this.$refs.customForm.getVal('gasSubsidyScaleMain');
      if (Number(gasSubsidyScaleMain) >= 0 && Number(gasSubsidyScaleMain) <= 100) {
        this.$refs.customForm.setVal('coGasSubsidyScaleMain', floatSub(100, gasSubsidyScaleMain));
        // 主驾和副驾油补计算
        let gasSubsidy = this.$refs.customForm.getVal('gasSubsidy');
        this.$refs.customForm.setVal('mainDriverGasSubsidy', Math.round(gasSubsidy * gasSubsidyScaleMain / 100));
        const mainDriverGasSubsidy = this.$refs.customForm.getVal('mainDriverGasSubsidy');
        this.$refs.customForm.setVal('coDriverGasSubsidy', gasSubsidy - mainDriverGasSubsidy);
      }
    },

    show (item, detailRes) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        this.detailRes = detailRes;
        this.setBaseForm();
        this.setDefaultData();
      });
    },
    // 根据“能源类型”显示不同表单
    setBaseForm () {
      let oilForm = ['kilometre', 'actualOilConsumption', 'standardOilConsumption', 'standardRise', 'oilRise', 'surplusRise', 'oilSubsidy', 'mainDriverSubsidy', 'oilSubsidyScaleMain', 'coDriverSubsidy', 'coOilSubsidyScaleMain', 'startingKilometerList', 'endKilometerList', 'oilRiseImgList'];
      let gasForm = ['surplusGasVolume', 'standardConsPerKilo', 'gasKilometre', 'actualGasInjectionVolume', 'startingKilometerImgList', 'endKilometerImgList', 'gasFillingQuantityImgList', 'actualConsPerKilo', 'standardGasInjectionVolume', 'gasSubsidy', 'mainDriverGasSubsidy', 'gasSubsidyScaleMain', 'coDriverGasSubsidy', 'coGasSubsidyScaleMain'];
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: this.detailRes.energyType === 'A' || this.detailRes.energyType === 'B',
        names: [...gasForm],
      });
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: this.detailRes.energyType === 'E',
        names: [...oilForm],
      });
    },
    async setDefaultData () {
      this.$refs.customForm.setVal('kilometre', this.originData.kilometreDouble);
      this.$refs.customForm.setVal('actualOilConsumption', this.originData.actualOilConsumptionDouble);
      this.$refs.customForm.setVal('standardOilConsumption', this.originData.standardOilConsumptionDouble);
      this.$refs.customForm.setVal('standardRise', this.originData.standardRiseDouble);
      this.$refs.customForm.setVal('oilRise', this.originData.oilRiseDouble);
      this.$refs.customForm.setVal('surplusRise', this.originData.surplusRiseDouble);
      this.$refs.customForm.setVal('oilSubsidy', this.originData.oilSubsidyDouble);
      this.$refs.customForm.setVal('mainDriverSubsidy', this.originData.mainDriverSubsidyDouble);
      this.$refs.customForm.setVal('coDriverSubsidy', this.originData.coDriverSubsidyDouble);
      if (this.originData.length === 0) {
        let _haveRemark = !!this.detailRes.orderScheduler.copilotUserId && this.detailRes.orderScheduler.vehicleClass === 1 && !!this.detailRes.vehicleInfo.remark && this.detailRes.vehicleInfo.remark.indexOf('外包') <= -1;
        let _noHaveRemark = !!this.detailRes.orderScheduler.copilotUserId && this.detailRes.orderScheduler.vehicleClass === 1 && !this.detailRes.vehicleInfo.remark;
        // 判断当前有主副驾的情况进行油补比例对半
        if (_haveRemark || _noHaveRemark) {
          // this.$refs.customForm.setVal('oilSubsidyScaleMain', 50);
          // this.$refs.customForm.setVal('coOilSubsidyScaleMain', 50);
          this.$refs.customForm.setVal('oilSubsidyScaleMain', 100);
          this.$refs.customForm.setVal('coOilSubsidyScaleMain', 0);
          this.$refs.customForm.setVal('gasSubsidyScaleMain', 100);
          this.$refs.customForm.setVal('coGasSubsidyScaleMain', 0);
        } else if (this.detailRes.orderInfoExt.reportingRole === 0 || this.detailRes.orderInfoExt.reportingRole === null) {
          this.$refs.customForm.setVal('oilSubsidyScaleMain', 100);
          this.$refs.customForm.setVal('coOilSubsidyScaleMain', 0);
          this.$refs.customForm.setVal('gasSubsidyScaleMain', 100);
          this.$refs.customForm.setVal('coGasSubsidyScaleMain', 0);
        } else {
          this.$refs.customForm.setVal('oilSubsidyScaleMain', 0);
          this.$refs.customForm.setVal('coOilSubsidyScaleMain', 100);
          this.$refs.customForm.setVal('gasSubsidyScaleMain', 0);
          this.$refs.customForm.setVal('coGasSubsidyScaleMain', 100);
        }
      } else {
        this.$refs.customForm.setVal('oilSubsidyScaleMain', this.originData.oilSubsidyScaleMainStr);
        this.$refs.customForm.setVal('coOilSubsidyScaleMain', this.originData.coOilSubsidyScaleMainStr);
        this.$refs.customForm.setVal('gasSubsidyScaleMain', this.originData.gasSubsidyScaleMainDouble);
        this.$refs.customForm.setVal('coGasSubsidyScaleMain', floatSub(100, this.originData.gasSubsidyScaleMainDouble));
      }
      this.setFormAttrVal({
        form: this.formData,
        attr: 'disabled',
        value: !this.detailRes.orderScheduler.copilotUserId,
        names: ['oilSubsidyScaleMain'],
      });

      this.$refs.customForm.setVal('gasKilometre', this.originData.kilometreDouble);
      this.$refs.customForm.setVal('actualConsPerKilo', this.originData.actualConsPerKiloDouble);
      this.$refs.customForm.setVal('actualGasInjectionVolume', this.originData.actualGasInjectionVolumeDouble);
      this.$refs.customForm.setVal('standardConsPerKilo', this.originData.standardConsPerKiloDouble);
      this.$refs.customForm.setVal('standardGasInjectionVolume', this.originData.standardGasInjectionVolumeDouble);
      this.$refs.customForm.setVal('surplusGasVolume', this.originData.surplusGasVolumeDouble);
      this.$refs.customForm.setVal('gasSubsidy', this.originData.gasSubsidyDouble);
      this.$refs.customForm.setVal('mainDriverGasSubsidy', this.originData.mainDriverGasSubsidyDouble);
      this.$refs.customForm.setVal('coDriverGasSubsidy', this.originData.coDriverGasSubsidyDouble);
      this.handlePicture('oilRiseImgList', this.originData.oilRiseImg, this.originData.oilRiseImgUrl);
      this.handlePicture('startingKilometerList', this.originData.startingKilometer, this.originData.startingKilometerUrl);
      this.handlePicture('endKilometerList', this.originData.endKilometer, this.originData.endKilometerUrl);
      this.handlePicture('startingKilometerImgList', this.originData.startingKilometerImg, this.originData.startingKilometerImgUrl);
      this.handlePicture('endKilometerImgList', this.originData.endKilometerImg, this.originData.endKilometerImgUrl);
      this.handlePicture('gasFillingQuantityImgList', this.originData.gasFillingQuantityImg, this.originData.gasFillingQuantityImgUrl);
    },
    // 统一处理图片 fieldName为表单名称，idField为图片id数据，urlField为图片url数据
    handlePicture (fieldName, idField, urlField) {
      if (idField) {
        let dataList = idField.split(',');
        let urlList = urlField.split(',');
        let files = dataList.map((flowId, index) => ({
          id: flowId,
          url: urlList[index],
        }));
        this.$refs.customForm.setVal(fieldName, files);
      }
    },
    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {

      let formData = null;
      for (let imgItem of aImgName) {
        const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
        if (form[imgItem] && form[imgItem].length) {
          let imgIds = [];
          let imgUrls = [];
          form[imgItem].forEach((item) => {
            imgIds.push(item.id);
            imgUrls.push(item.url);
          });
          form[imgField] = imgIds.join(',');
          form[imgField + 'Url'] = imgUrls.join(',');
        } else {
          form[imgField] = '';
          form[imgField + 'Url'] = '';
        }
      }
      if (this.originData.id) {
        form.id = this.originData.id;
      }
      delete form.startingKilometerList;
      delete form.endKilometerList;
      delete form.oilRiseImgList;
      delete form.startingKilometerImgList;
      delete form.endKilometerImgList;
      delete form.gasFillingQuantityImgList;
      if (this.detailRes.energyType === 'E') {

        delete form.oilSubsidyScaleMain;
        delete form.coOilSubsidyScaleMain;
      }
      if (form) {
        formData = {
          orderId: this.originData.orderId || this.$route.query.id,
          ...form,
        };
      }
      console.log('formData', formData);
      this.subLoading = true;
      let res;
      if (this.detailRes.energyType === 'A' || this.detailRes.energyType === 'B') {
        res = await oilConsumptionSaveOrUpdate(formData);
      } else if (this.detailRes.energyType === 'E') {
        formData.kilometre = formData.gasKilometre;
        delete formData.gasKilometre;
        delete formData.startingKilometer;
        delete formData.startingKilometerUrl;
        delete formData.endKilometer;
        delete formData.endKilometerUrl;
        delete formData.oilRiseImg;
        delete formData.oilRiseImgUrl;
        res = await gasConsumptionSaveOrUpdate(formData);
      }
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.subLoading = false;
        this.$message({
          type: 'success',
          message: '上传成功',
        });
        this.$emit('sub');
      }
    },
  },

};
</script>

<style>
</style>
